import React, { useEffect, useState } from "react";
import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Plus, X } from "lucide-react";

function AdminLiveTrades({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [data, setData] = useState([]);
  const [noTrade, setNoTrade] = useState(0);
  const [loader, setLoader] = useState(true);
  const [inputData, setInputData] = useState({});
  const [prices, setPrices] = useState({});
  const [hasOpenTrades, setHasOpenTrades] = useState(false);
  const [timeFrame, setTimeFrame] = useState("4h");
  const [rangeStats, setRangeStats] = useState({
    totalTrades: 0,
    totalPnl: 0,
    profitTrades: 0,
    lossTrades: 0,
  });

  const [stats, setStats] = useState({
    totalPnl: 0,
    lossTrades: 0,
    profitTrades: 0,
    totalTrades: 0,
    weekProfitTrades: 0,
    weekLossTrades: 0,
    weekTotalLong: 0,
    weekTotalshort: 0,
  });

  const getTradeData = async (p, filters) => {
    try {
      // console.log(filters);

      const payload = { page: p, ...filters };
      setLoader(true);
      const resp = await api.liveTradeGetAdmin(payload);
      setData(resp.trades);
      setNoTrade(resp.total);
      setLimit(resp.limit);
      setPrices(resp?.prices);

      const openExists = resp.trades.some((t) => t.status === "OPEN");
      setHasOpenTrades(openExists);

      // setStats({
      //   pending: pendingCount,
      //   processing: processingCount,
      //   closed: closedCount,
      //   total: resp.count,
      // });

      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const getTradeStats = async () => {
    try {
      // console.log(filters);

      setLoader(true);
      const resp = await api.liveTradeStats();
      console.log(resp);

      setStats({
        totalPnl: resp?.portfolio?.stats?.totalPnl || 0,
        lossTrades: resp?.portfolio?.stats?.lossTrades || 0,
        profitTrades: resp?.portfolio?.stats?.profitTrades || 0,
        totalTrades: resp?.portfolio?.stats?.totalTrades || 0,
        weekProfitTrades: resp?.weekly?.stats?.profitTrades,
        weekLossTrades: resp?.weekly?.stats?.lossTrades || 0,
        weekTotalLong: resp?.weekly?.stats?.totalLong || 0,
        weekTotalshort: resp?.weekly?.stats?.totalShort || 0,
      });

      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };
  const updatePnlTrades = async () => {
    try {
      // console.log(filters);

      setLoader(true);
      const resp = await api.liveTradeUpdatePnl();
      console.log(resp);
      if (resp?.success) {
        alert("PNL successfully added to old trades.");
        getTradeStats();
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleReset = () => {
    setInputData({});
    setPage(1);
  };

  useEffect(() => {
    getTradeData(page, inputData);
  }, [inputData, page]);

  useEffect(() => {
    if (!hasOpenTrades) return;

    const interval = setInterval(() => {
      getTradeData(page, inputData);
    }, 15000);

    return () => clearInterval(interval);
  }, [hasOpenTrades]);

  useEffect(() => {
    getTradeStats();
  }, []);

  function formatDecimal(value) {
    const decimalPart = value.toString().split(".")[1];
    if (decimalPart && decimalPart.length > 4) {
      return Number(value.toFixed(2));
    }

    return value;
  }

  const formatNumberUnit = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "0.00";

    const absValue = Math.abs(value);

    if (absValue >= 1e9) {
      return (value / 1e9).toFixed(2) + "B";
    }

    if (absValue >= 1e6) {
      return (value / 1e6).toFixed(2) + "M";
    }

    return Number(value).toFixed(2);
  };

  const getStatsByRange = async () => {
    try {
      // console.log(filters);

      setLoader(true);
      const resp = await api.liveTradeGetByRange({ range: timeFrame });
      console.log(resp);
      if (resp?.success) {
        setRangeStats(resp?.stats || {});
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getStatsByRange();
  }, [timeFrame]);

  return (
    <>
      <div className="container-fluid admin-dashboard support-tickets-page">
        {/* Stats Cards */}

        {/* Page Header */}
        <div className="row page-header mb-4">
          <div className="col-12">
            <div className="page-header-card">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h1 className="page-title">Live Trades</h1>
                  <p className="page-subtitle">
                    Manage and monitor all live trades
                  </p>
                </div>
                <div className="header-actions">
                  {/* <button
                    className="btn-action refresh-btn"
                    onClick={() => updatePnlTrades()}
                    title="Refresh"
                  >
                    Add PNL To Old Trade
                  </button> */}
                  <button
                    className="btn-action refresh-btn"
                    onClick={() => getTradeData(page, inputData)}
                    title="Refresh"
                  >
                    <i className="fas fa-sync-alt"></i> Refresh
                  </button>
                  {/* <AddTrade getTradeData={getTradeData} /> */}
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon total">
                      <i className="fa-solid fa-chart-simple"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{stats?.totalTrades}</h3>
                      <p className="stats-label">Total Trades</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon image-trades-icon">
                      <i className="fa-solid fa-wallet"></i>
                    </div>
                    <div className="stat-content">
                      <h3
                        className={
                          formatDecimal(stats?.totalPnl) >= 0
                            ? "text-success  "
                            : "text-danger "
                        }
                        style={{ fontSize: 24, marginBottom: 4 }}
                      >
                        $
                        {stats?.totalPnl
                          ? formatNumberUnit(stats?.totalPnl)
                          : 0}
                      </h3>
                      <p className="stats-label">Total Portfolio</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon file-trades-icon">
                      <i className="fa-solid fa-arrow-trend-up"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{stats?.profitTrades}</h3>
                      <p className="stats-label">All Profit Trades</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon video-trades-icon">
                      <i className="fa-solid fa-arrow-trend-down"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{stats?.lossTrades}</h3>
                      <p className="stats-label">All Loss Trades</p>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon  file-trades-icon">
                      <i className="fa-solid fa-arrow-trend-up"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{stats?.weekProfitTrades}</h3>
                      <p className="stats-label">Week Profit Trades</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon video-trades-icon">
                      <i className="fa-solid fa-arrow-trend-down"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{stats?.weekLossTrades}</h3>
                      <p className="stats-label">Week Loss Trades</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon total-trades-icon">
                      <i className="fa-solid fa-arrow-up-wide-short"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{stats?.weekTotalLong}</h3>
                      <p className="stats-label">Week Total Long</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon image-trades-icon">
                      <i className="fa-solid fa-arrow-down-wide-short"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{stats?.weekTotalshort}</h3>
                      <p className="stats-label">Week Total Short</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row my-2">
                <div className="col-lg-3 col-sm-6">
                  <div className="filter-group">
                    <h5 className="">Timeframe</h5>
                    <div className="select-wrapper">
                      <i className="fas fa-caret-down select-arrow"></i>
                      <select
                        name="position"
                        onChange={(e) => setTimeFrame(e.target.value)}
                        value={timeFrame}
                        className="filter-select"
                      >
                        <option value="4h">4H</option>
                        <option value="1d">1D</option>
                        <option value="2d">2D</option>
                        <option value="3d">3D</option>
                        <option value="4d">4D</option>
                        <option value="5d">5D</option>
                        <option value="6d">6D</option>
                        <option value="7d">7D</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon total">
                      <i className="fa-solid fa-chart-simple"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{rangeStats?.totalTrades}</h3>
                      <p className="stats-label">Total Trades</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon image-trades-icon">
                      <i className="fa-solid fa-wallet"></i>
                    </div>
                    <div className="stat-content">
                      <h3
                        className={
                          formatDecimal(rangeStats?.totalPnl) >= 0
                            ? "text-success  "
                            : "text-danger "
                        }
                        style={{ fontSize: 24, marginBottom: 4 }}
                      >
                        $
                        {rangeStats?.totalPnl
                          ? formatNumberUnit(rangeStats?.totalPnl)
                          : 0}
                      </h3>
                      <p className="stats-label">Portfolio</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon file-trades-icon">
                      <i className="fa-solid fa-arrow-trend-up"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">
                        {rangeStats?.profitTrades}
                      </h3>
                      <p className="stats-label">Profit Trades</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3  col-sm-6 col-lg-4 mb-2">
                  <div className="stat-card">
                    <div className="stat-icon video-trades-icon">
                      <i className="fa-solid fa-arrow-trend-down"></i>
                    </div>
                    <div className="stat-content">
                      <h3 className="stat-number">{rangeStats?.lossTrades}</h3>
                      <p className="stats-label">Loss Trades</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="row filter-section mb-4">
          <div className="col-12">
            <div className="filter-card">
              <div className="filter-header">
                <div className="filter-label">
                  <i className="fas fa-filter"></i> Filter Trade
                </div>
              </div>
              <div className="filter-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="filter-group">
                      <label className="filter-label-small">Position</label>
                      <div className="select-wrapper">
                        <i className="fas fa-caret-down select-arrow"></i>
                        <select
                          name="position"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              position: e.target.value,
                            })
                          }
                          value={inputData?.position}
                          className="filter-select"
                        >
                          <option value="">Select Issue</option>
                          <option value="LONG">LONG</option>
                          <option value="SHORT">SHORT</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="filter-group">
                      <label className="filter-label-small">Status</label>
                      <div className="select-wrapper">
                        <i className="fas fa-caret-down select-arrow"></i>
                        <select
                          name="status"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              status: e.target.value,
                            })
                          }
                          value={inputData?.status}
                          className="filter-select"
                        >
                          <option value="">Select Status</option>
                          <option value="OPEN">OPEN</option>
                          <option value="CLOSED">CLOSED</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="filter-group">
                      <label className="filter-label-small">
                        Trade Type (Coming Soon)
                      </label>
                      <div className="select-wrapper">
                        <i className="fas fa-caret-down select-arrow"></i>
                        <select
                          name="status"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              tradeType: e.target.value,
                            })
                          }
                          value={inputData?.status}
                          className="filter-select"
                        >
                          <option value="godzilla">Godzilla</option>
                          <option value="stocks">Stocks</option>
                          <option value="live trades">Live Trades</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="filter-actions mt-3">
                  <button
                    className="themeBlackBtn"
                    onClick={() => handleReset()}
                  >
                    <i className="fas fa-redo"></i> Reset Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Table */}
        <div className="row">
          <div className="col">
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noTrade={noTrade}
              limit={limit}
              prices={prices}
              getTradeData={getTradeData}
            />
          </div>
        </div>
      </div>

      {loader && <Loader />}
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noTrade,
  limit,
  prices,
  getTradeData,
}) => {
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);
  const navigate = useNavigate();
  const [closeLoader, setCloseLoader] = useState(false);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const calcPnl = (trade, livePrice) => {
    if (!livePrice) return null;

    return trade.position === "LONG"
      ? livePrice - trade.entryPrice
      : trade.entryPrice - livePrice;
  };

  const calcPnlPercent = (trade, livePrice) => {
    const pnl = calcPnl(trade, livePrice);
    if (pnl === null) return null;
    return Number(((pnl / trade.entryPrice) * 100).toFixed(2));
  };

  const handleCloseTrade = async (tradeId) => {
    try {
      setCloseLoader(true);
      const formData = {
        tradeId,
      };

      const signalResponse = await api.liveTradeClose(formData);
      if (signalResponse?.success) {
        setCloseLoader(false);
        getTradeData();
      } else {
        setCloseLoader(false);
      }
    } catch (error) {
      setCloseLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  function formatDecimal(value) {
    const decimalPart = value.toString().split(".")[1];
    if (decimalPart && decimalPart.length > 4) {
      return Number(value.toFixed(4));
    }

    return value;
  }

  const MARGIN = 100;
  const LEVERAGE = 100;
  const POSITION_SIZE = MARGIN * LEVERAGE; // 10000

  const calcPnlValue = (trade, exitPrice) => {
    if (!exitPrice) return null;

    const { entryPrice, position } = trade;

    if (!entryPrice || !position) return null;

    let pnl;

    if (position === "LONG") {
      pnl = (POSITION_SIZE * (exitPrice - entryPrice)) / entryPrice;
    } else if (position === "SHORT") {
      pnl = (POSITION_SIZE * (entryPrice - exitPrice)) / entryPrice;
    } else {
      return null;
    }

    return Number(pnl.toFixed(2)); // $ value
  };

  return (
    <>
      <div className="card modern-table-card">
        <div className="table-header-section">
          <div className="table-title-group flex-wrap jc-sb ai-center p-3">
            <div className="d-flex flex-wrap ai-center">
              <h3 className="table-title me-3">All Trades</h3>
              <div className="margineTitle">
                Margin: <span>$100</span>
              </div>
              <div className="margineTitle">
                Leverage: <span>100x</span>
              </div>
            </div>
            <span className="table-subtitle">{noTrade} trade found</span>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table modern-table tickets-table">
            <thead className="table-header">
              <tr>
                <th className="table-head-cell">Coin</th>
                <th className="table-head-cell">Position</th>
                <th className="table-head-cell">Entry Price</th>
                <th className="table-head-cell">Target Price</th>
                <th className="table-head-cell">Closed Price</th>
                <th className="table-head-cell">Status</th>
                <th className="table-head-cell">Closed Reason</th>
                {/* <th className="table-head-cell">PNL</th> */}
                <th className="table-head-cell">PNL $</th>
                {/* <th className="table-head-cell">PNL %</th> */}
                <th className="table-head-cell">Opened At</th>
                <th className="table-head-cell">Closed At</th>
                <th className="table-head-cell">Action</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {data.map((item, key) => (
                <tr key={key} className="table-row">
                  <td className="table-cell">
                    <div className="issue-id">{item?.coin}</div>
                  </td>
                  <td className="table-cell">
                    <div className="user-email">{item?.position}</div>
                  </td>
                  <td className="table-cell">
                    <div>
                      {item?.entryPrice
                        ? "$" + formatDecimal(item?.entryPrice)
                        : "-"}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="issue-type">${item?.targetPrice}</div>
                  </td>
                  <td className="table-cell">
                    <div className="issue-type">
                      {item?.closedPrice
                        ? "$" + formatDecimal(item?.closedPrice)
                        : "-"}
                    </div>
                  </td>

                  <td className="table-cell">
                    <div
                      className={`status-badge ${item?.status == "OPEN" ? "status-processing" : "status-closed"}`}
                    >
                      {item?.status}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="issue-type">{item?.closeReason || "-"}</div>
                  </td>
                  {/* <td className="table-cell">
                    {calcPnl(item, prices[item.coin])?.toFixed(4) ?? "-"}
                  </td> */}
                  <td className="table-cell">
                    {item.status === "OPEN" && prices?.[item.coin] ? (
                      <span
                        className={
                          calcPnlValue(item, prices[item.coin]) >= 0
                            ? "text-success d-flex"
                            : "text-danger d-flex"
                        }
                      >
                        ${calcPnlValue(item, prices[item.coin])}
                      </span>
                    ) : item.status === "CLOSED" && item.closedPrice ? (
                      <span
                        className={
                          calcPnlValue(item, item.closedPrice) >= 0
                            ? "text-success d-flex"
                            : "text-danger d-flex"
                        }
                      >
                        ${calcPnlValue(item, item.closedPrice) ?? 0}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                  {/* <td className="table-cell">
                    {item.status === "OPEN" && prices?.[item.coin] ? (
                      <span
                        className={
                          calcPnl(item, prices[item.coin]) >= 0
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {calcPnlPercent(item, prices[item.coin])}%
                      </span>
                    ) : item.status === "CLOSED" && item.closedPrice ? (
                      <span
                        className={
                          calcPnl(item, item.closedPrice) >= 0
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {calcPnlPercent(item, item.closedPrice) ?? 0}%
                      </span>
                    ) : (
                      "-"
                    )}
                  </td> */}

                  <td className="table-cell">
                    <div className="created-at">
                      {formatDate(item?.openedAt)}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="created-at">
                      {item?.closedAt ? formatDate(item?.closedAt) : "-"}
                    </div>
                  </td>
                  <td className="table-cell">
                    {item?.status == "OPEN" ? (
                      <button
                        onClick={() => handleCloseTrade(item?._id)}
                        disabled={closeLoader}
                        className="themeBlackBtn jc-center"
                      >
                        {closeLoader && (
                          <i
                            className="fa fa-spinner fa-pulse mx-2 mb-1"
                            style={{ position: "relative", top: "-0px" }}
                          ></i>
                        )}
                        Close Trade
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {data.length === 0 && (
          <div className="empty-table-state">
            <div className="empty-state-content">
              <i className="fas fa-ticket-alt empty-state-icon"></i>
              <h4 className="empty-state-title">No trade found</h4>
              <p className="empty-state-description">
                There are no trade matching your criteria.
              </p>
            </div>
          </div>
        )}

        {data.length > 0 && (
          <div className="table-footer">
            <div className="table-info">
              Showing {data.length} of {noTrade} trade • Page {page} of{" "}
              {Math.ceil(noTrade / limit)}
            </div>
            <div className="table-pagination">
              <Stack spacing={2}>
                <Pagination
                  count={Math.ceil(noTrade / limit)}
                  page={page}
                  onChange={handleChange}
                  color="primary"
                  shape="rounded"
                />
              </Stack>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const AddTrade = ({ getTradeData }) => {
  const [inputData, setInputData] = useState({});
  const [loader, setLoader] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleChange = (e) => {
    // console.log(e);
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (!inputData?.coin && !inputData?.position && !inputData?.targetPrice) {
        setLoader(false);
        alert("Please fill required fields.");
        return;
      }

      setLoader(true);
      const formData = {
        coin: inputData?.coin,
        position: inputData?.position,
        entryPrice: inputData?.entryPrice || "",
        targetPrice: inputData?.targetPrice,
      };

      // console.log(formData);

      const signalResponse = await api.liveTradeCreate(formData);
      if (signalResponse?.success) {
        alert("Form submited");
        setInputData({
          position: "",
        });

        setLoader(false);
        setShow(false);
        getTradeData();
      } else {
        setLoader(false);
        alert("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  return (
    <>
      <button className="add-video-btn" onClick={handleShow}>
        <Plus size={20} />
        <span>Add Trade</span>
      </button>
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <h2 className="modal-title">Add Trade</h2>
              <button className="close-modal-btn" onClick={handleClose}>
                <X size={24} />
              </button>
            </div>
            <div className="modal-body-content">
              <div className="card sortby-box br-10 border-transparent mt-3">
                <div className="card-header br-10  bg-white border-transparent py-3 ">
                  <div className="descMainPost">
                    <div className="form-group mb-3">
                      <input
                        type="text"
                        name="coin"
                        className="form-control"
                        onChange={handleChange}
                        placeholder="Add Coin*"
                      />
                    </div>
                  </div>
                  <div className="form-group mb-3">
                    <select
                      name="position"
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Position*</option>
                      <option value="LONG">LONG</option>
                      <option value="SHORT">SHORT</option>
                    </select>
                  </div>
                  <div className="form-group mb-3">
                    <input
                      type="number"
                      name="entryPrice"
                      className="form-control"
                      onChange={handleChange}
                      placeholder="Add Entry Price"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <input
                      type="number"
                      name="targetPrice"
                      className="form-control"
                      onChange={handleChange}
                      placeholder="Add Target Price*"
                    />
                  </div>

                  <div className="sendMailBtn mt-3">
                    <button
                      onClick={handleSubmit}
                      className="btn-dark"
                      disabled={loader}
                    >
                      {loader && (
                        <i
                          className="fa fa-spinner fa-pulse mx-2 mb-1"
                          style={{ position: "relative", top: "-0px" }}
                        ></i>
                      )}
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AdminLiveTrades;
